// extracted by mini-css-extract-plugin
module.exports = {"lessSpacing":"SurveySlice_lessSpacing__lnzgX","frame":"SurveySlice_frame__v0zkl","small":"SurveySlice_small__qEvy5","slideUp":"SurveySlice_slideUp__h0xEY"};